import type { ReactNode } from 'react'
import { Lock } from 'lucide-react'
import { useAuth } from '../store/auth'
import { EmptyState } from './EmptyState'
import type { ModuleKey } from '../types'

interface Props {
  module: ModuleKey
  children: ReactNode
}

// Protects direct URL navigation to a module's pages even when its nav entry is hidden —
// Layout.tsx already filters the nav, this is the corresponding route-level guard.
export function RequireModule({ module, children }: Props) {
  const { user } = useAuth()

  if (!user?.enabledModules?.includes(module)) {
    return (
      <EmptyState
        icon={Lock}
        title="Module not enabled"
        description="This module isn't enabled for your business. Ask your business administrator to enable it in Settings > Modules."
      />
    )
  }

  return <>{children}</>
}
